export type ToastKind = "success" | "error" | "info" | "warn";

export interface ToastMessage {
  id: number;
  kind: ToastKind;
  message: string;
}

export const TOAST_EVENT = "eldoo-toast";

const emitToast = (kind: ToastKind, message: string) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<ToastMessage>(TOAST_EVENT, {
      detail: {
        id: Date.now() + Math.floor(Math.random() * 1000),
        kind,
        message,
      },
    }),
  );
};

export const toast: Record<ToastKind, (message: string) => void> = {
  success: (message) => emitToast("success", message),
  error: (message) => emitToast("error", message),
  info: (message) => emitToast("info", message),
  warn: (message) => emitToast("warn", message),
};
